import React, { useState } from "react";
import SchemaForm from "components/util/schema_form/SchemaForm";
import EditSubmitComponent from "components/studio/board/node_form/NodeFormView.sub.EditSubmit.view";
import { HelpComponent } from "components/util/schema_form/util/help_util";
import DocumentationModal from "components/studio/board/node_form/NodeFormView.sub.DocumentationModal.view";

import l from "components/util/l";
import "styles/css/studio/board/NodeForm.css";


const getActionTitle = (action) => {
  let nodeIcon = action?.app?.uiSettings?.icon;
  let nodeTitle = action?.uiSettings?.form?.title ?? action?.uiSettings?.general?.title;
  let helpMessage = action?.uiSettings?.form?.caption ?? action?.uiSettings?.general?.caption ?? "";
  return (
    <div>
      <small className="px-2 py-1 mr-2" id="app-detail">
        <i id="app_detail_icon" className={nodeIcon}></i>
      </small>
      {l(nodeTitle)}
      <small className="ml-1" style={{ color: "#aaacb0" }}>
        {helpMessage !== "" ? <label className="mr-1 ml-1">-&nbsp;{l(helpMessage)}</label> : null}
      </small>
    </div>
  );
};

const NodeFormView = ({
  node = {},
  action,
  flowId,
  parentId,
  activePageId,
  initialData,
  isEditing = false,
  isAnnotation = false,
  onDeleteNode = () => {},
  onSubmit,
}) => {
  const [showDoc, setShowDoc] = useState(false);
  const doc = action?.uiSettings?.form?.documentation || {};

  return (
    <>
      <div className="card" id="node-form">
        <div className="card-header">
          <div className="w-100">
            <div className="d-flex justify-content-between align-items-center">
              <h3 className="node-form-title mb-0">
                <span>{!isEditing ? l("Crear acción%SA224") : l("Editar acción%SA225")}</span>
                {getActionTitle(action)}
              </h3>

              {/* Temp hide 250921
              <button
                type="button"
                className="btn btn-outline-primary ml-3"
                onClick={() => setShowDoc(true)}
                title={l("Ver documentación")}
              >
                <i className="fas fa-book-open mr-1"></i>
                {l("Documentación")}
              </button>
              */}
            </div>
          </div>
        </div>

        <div className="card-body pt-5">
          <div id="node-form-schema">
            <SchemaForm
              schema={action.uiSettings?.form?.fields ?? []}
              appId={action?.app?.id}
              actionId={action?.id}
              flowId={flowId}
              nodeId={node?.id}
              parentId={parentId}
              initialValues={initialData}
              submitComponent={isEditing ? () => <EditSubmitComponent onDeleteNode={onDeleteNode} /> : null}
              submitText={!isEditing ? l("Crear acción%SA224") : null}
              onSubmit={onSubmit}
            />
          </div>
        </div>
      </div>
      {showDoc && <DocumentationModal doc={doc} onClose={() => setShowDoc(false)} />}
    </>
  );
};

export default NodeFormView;